import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Voicemail.svg",
  "use": "Voicemail.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Voicemail.svg\"><path d=\"M52.01,50.0208h-40a6,6,0,0,1-6-6v-24a6,6,0,0,1,6-6h40a6,6,0,0,1,6,6v24A6,6,0,0,1,52.01,50.0208Zm-8-28a9.9866,9.9866,0,0,0-7.9865,16H27.9969a9.9909,9.9909,0,1,0-7.9864,4h24a10,10,0,0,0,0-20Zm0,16a6,6,0,1,1,6-6A6,6,0,0,1,44.01,38.0209Zm-24,0a6,6,0,1,1,6-6A6,6,0,0,1,20.01,38.0209Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol